module.exports = __webpack_public_path__ + "img/7.1eecb050.png";